import firebase from "firebase";

firebase.initializeApp({
  apiKey: "AIzaSyB17OBAxo8idz8d2vh6AvTR-eBvGQF2W8o",
  authDomain: "gamers-world-d45d7.firebaseapp.com",
});
export default firebase;
